const emptyBudget = {
  month: undefined,
  year: undefined,
  balance: 0,
  items: []
}

export function create(data = {}) {
  const { month, year } = data

  return {
    ...emptyBudget,
    month,
    year
  }
}
